import { render, staticRenderFns } from "./AddAssignmentWrapper.vue?vue&type=template&id=297de9a3&scoped=true&"
import script from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
export * from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignmentWrapper.vue?vue&type=style&index=0&id=297de9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297de9a3",
  null
  
)

export default component.exports